import Button from '@mui/material/Button';
import React from 'react';

const CustomPrimaryButton = ({
	label,
	additionalStyles,
	disabled,
	onClick,
}) => {
	return (
		<Button
			variant='contained'
			sx={{
				bgcolor: '#f97316',
				color: 'white',
				textTransform: 'none',
				fontSize: '16px',
				fontWeight: 500,
				width: '100%',
				height: '44px',
				borderRadius: '4px',
				boxShadow: 'none',
				'&:hover': {
					bgcolor: '#ea580c',
					boxShadow: 'none',
				},
				'&.Mui-disabled': {
					bgcolor: '#4f5660',
					color: '#b9bbbe',
					opacity: 0.55,
				},
			}}
			style={additionalStyles ? additionalStyles : {}}
			disabled={disabled}
			onClick={onClick}>
			{label}
		</Button>
	);
};

export default CustomPrimaryButton;
